export { GroupResourcesPane } from './GroupResourcesPane';
